import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';

/**
 * Modal de confirmación para eliminar una incidencia
 */
const TagDeleteModal = ({
  itemToDelete,
  isDeleting,
  isDark,
  onClose,
  onConfirm
}) => {
  if (!itemToDelete) return null;

  return (
    <div
      className="modal d-block"
      style={{ backgroundColor: 'rgba(0,0,0,0.6)', zIndex: 1050 }}
      tabIndex="-1"
    >
      <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: '420px' }}>
        <div
          className="modal-content border shadow-lg"
          style={{
            backgroundColor: isDark ? '#182635' : '#ffffff',
            borderColor: isDark ? '#233142' : '#cbd5e1'
          }}
        >
          <div className="modal-body px-4 py-4 text-center">
            <div
              className="rounded-circle mx-auto d-flex align-items-center justify-content-center mb-3 text-danger"
              style={{
                width: '48px',
                height: '48px',
                backgroundColor: isDark ? 'rgba(239, 68, 68, 0.15)' : '#fee2e2'
              }}
            >
              <FontAwesomeIcon icon={faTrash} style={{ fontSize: '1.2rem' }} />
            </div>
            <h6 className="fw-bold mb-2" style={{ color: isDark ? '#f9fafd' : '#0f172a' }}>
              ¿Eliminar Incidencia?
            </h6>
            <p className="small text-muted mb-3" style={{ fontSize: '0.85rem' }}>
              ¿Estás seguro de que deseas eliminar la incidencia{' '}
              <strong style={{ color: isDark ? '#f8fafc' : '#0f172a' }}>"{itemToDelete.vNombre}"</strong>?
              Esta etiqueta ya no aparecerá en el catálogo para clasificar nuevos tickets.
            </p>

            <div className="d-flex align-items-center justify-content-center gap-2">
              <button
                type="button"
                className="btn btn-sm btn-outline-secondary rounded-pill px-3 shadow-none"
                onClick={onClose}
                disabled={isDeleting}
              >
                Cancelar
              </button>
              <button
                type="button"
                className="btn btn-sm btn-danger rounded-pill px-4 shadow-none fw-semibold"
                onClick={onConfirm}
                disabled={isDeleting}
              >
                {isDeleting ? 'Eliminando...' : 'Sí, Eliminar'}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TagDeleteModal;
